import { NgModule, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { UIRouterModule } from '@uirouter/angular';
import { StateService } from '@uirouter/core';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { PasswordModule } from 'primeng/password';

import { AuthService } from '@app/auth/auth.service';
import { GlobalModule } from '@global/global.module';
import { MustMatch } from '@helpers/must-match.validator';
import { ParametreService } from '@app/parametre/parametre.service';

@Component({
	selector: 'change-password',
	templateUrl: 'change-password.html'
})
export class ChangePasswordComponent implements OnInit {

	messageSuccess = 'Changement de mot de passe effectué. Vous allez être redirigé vers le formulaire de connexion.';
	token = '';
	changePasswordForm: FormGroup;
	submitted = false;
	success = false;
	loading = false;

	criterias: any = {
		nb_letters: {pattern: /[a-zA-Z]+/, result: -1},
		nb_numbers: {pattern: /\d+/, result: -1},
		uppercase: {pattern: /[A-Z]+/, result: -1},
		lowercase: {pattern: /[a-z]+/, result: -1},
		nb_chars: {pattern: /.{8,}/, result: -1},
	}

	constructor(
		private authService: AuthService,
		private formBuilder: FormBuilder,
		private parametreService: ParametreService,
		private stateService: StateService,
	) {

	}

	ngOnInit() {
		const passwordPattern = new RegExp(this.parametreService.getParam('password_pattern'));
		this.token = this.stateService.params.resetPasswordToken;
		this.changePasswordForm = this.formBuilder.group({
			password: ['', [Validators.required, Validators.pattern(passwordPattern)] ],
			passwordConfirm: ['', Validators.required],
		},
		{
			validator: MustMatch('password', 'passwordConfirm')
		});
	}

	get f() { return this.changePasswordForm.controls; }

	onSubmit() {
		this.loading = false;
		this.submitted = true;
		this.authService.changementMotDePasse(this.f.password.value, this.f.passwordConfirm.value, this.token)
		.subscribe(
			ok => {
				this.success = true;
				setTimeout(() => {
					this.stateService.go('auth.login');
				}, 5000);
			},
			error => {

			}
		).add(() => { this.loading = false; });
	}

	criteriaChecked(pattern: string): number {
		if (!this.f.password.value) {
			return -1;
		}
		else {
			if (this.f.password.value.match(pattern)) {
				return 1;
			}
			return 0;
		}
	}

	checkCriterias() {
		for (let criteria in this.criterias) {
			this.criterias[criteria].result = this.criteriaChecked(this.criterias[criteria].pattern);
		}
	}
}

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		UIRouterModule,
		ReactiveFormsModule,
		ButtonModule,
		PasswordModule,
		InputTextModule,
		MessageModule,
		GlobalModule,
	],
	exports: [ChangePasswordComponent],
	declarations: [ChangePasswordComponent]
})
export class ChangePasswordModule { }
